export const updateFileCollection = (value, i, setter) =>
  setter((prev) => {
    prev[i] = value;
    return [...prev];
  })


export const sumProgress = (progress) =>
  progress.reduce(
    (result, current) => ({
      loaded: current.loaded + result.loaded,
      total: current.total + result.total,
    }),
    { loaded: 0, total: 0 },
  );

export const buildProgress = ({ loaded, total }) => ({
  loaded,
  total,
  percent: total ? (loaded / total) * 100 : 0,
});
